export const frequencyOfBilling = [
    { 
        "value": "Daily",
        "label": "Daily"
    },
    { 
        "value": "Weekly",
        "label": "Weekly"
    },
    { 
        "value": "Biweekly",
        "label": "Biweekly"
    },
    { 
        "value": "Monthly",
        "label": "Monthly"
    },
    { 
        "value": "Bimonthly",
        "label": "Bimonthly"
    },
    { 
        "value": "Quaterly",
        "label": "Quaterly"
    },
    { 
        "value": "Half-yearly",
        "label": "Half-yearly"
    },
    { 
        "value": "Yearly",
        "label": "Yearly"
    },
    { 
        "value": "Others / Not Applicable",
        "label": "Others / Not Applicable"
    },
  ];